module.exports = __webpack_public_path__ + "files/e873693230bd7df4d17602e674d2f469.png";